import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setFavoriteNodeViewStateMutator', function setFavoriteNodeViewStateMutator(favoriteId, viewState) {
    getStore().favoriteNodeViewStates.set(favoriteId, viewState);
});
//# sourceMappingURL=setFavoriteNodeViewStateMutator.js.map